import * as Sentry from "@sentry/react"
import i18next from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import resourcesToBackend from 'i18next-resources-to-backend'
import ReactDOM from 'react-dom/client'
import { initReactI18next } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.scss'
import reportWebVitals from './reportWebVitals'


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

Sentry.init({
    dsn: "https://0a659073db48de07c7045977242bef20@o379493.ingest.sentry.io/4506316371132416",
    integrations: [
        new Sentry.BrowserTracing({
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: ["localhost", /^https:\/\/ckm-billing-.*\.web\.app/],
        }),
    ],
})

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(resourcesToBackend((language: string, namespace: string) =>
        import(`../translations/${language}/${namespace}.json`)
    ))
    .init({
        detection: {
            order: ['querystring'],
            lookupQuerystring: 'locale',
        },
        interpolation: {
            escapeValue: false,
            prefix: '%{',
            suffix: '}',
        },
        fallbackLng: "en",
        ns: "latest",
        defaultNS: "latest"
    }, () => { })

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
